import { Injectable, Output, EventEmitter } from '@angular/core';

export interface MenuItem {
    text: string,
    route: string,
    image: string,
    submenu: Array<SubMenuItem>
}

export interface SubMenuItem {
    text: string,
    route: string
}

@Injectable()
export class MenuService {
    @Output() activeMenuItemChanged: EventEmitter<MenuItem> = new EventEmitter<MenuItem>();

    items: Array<MenuItem>;
    activeMenuItem: MenuItem;

    setActiveMenuItem(item: MenuItem) {
        this.activeMenuItem = item;
        this.activeMenuItemChanged.emit(this.activeMenuItem);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/fw/services/menu.service.ts